import { render, staticRenderFns } from "./need_raid_item_box.vue?vue&type=template&id=3b72807c"
import script from "./need_raid_item_box.vue?vue&type=script&lang=ts"
export * from "./need_raid_item_box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports